import React, { useState } from 'react'
import Validation from '../forms/validation'
import Alert from '../alerts'
import { auth } from '../../firebase'
import { sendPasswordResetEmail } from 'firebase/auth'

const ForgotPassword = ({ message = null }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)
  let items = [
    {
      label: 'Email',
      error: { required: 'Silakan masukkan email yang valid' },
      name: 'email',
      type: 'email',
      placeholder: 'Masukkan email Anda'
    },
  ]

  const onSubmit = (formData) => {
    setLoading(true)
    setErrorMessage(null)
    setSuccessMessage(null)

    sendPasswordResetEmail(auth, formData.email)
      .then(() => {
        setSuccessMessage('Email pengaturan ulang kata sandi berhasil dikirim! Periksa inbox Anda.')
        setData(formData)
        setLoading(false)
      })
      .catch((error) => {
        setErrorMessage(error.message)
        setLoading(false)
      })
  }

  return (
    <>
      <div className="flex flex-col">
        {successMessage && (
          <div className="w-full mb-4">
            <Alert
              color="bg-transparent border-green-500 text-green-500"
              borderLeft
              raised>
              {successMessage}
            </Alert>
          </div>
        )}
        {errorMessage && (
          <div className="w-full mb-4">
            <Alert
              color="bg-transparent border-red-500 text-red-500"
              borderLeft
              raised>
              {errorMessage}
            </Alert>
          </div>
        )}
        <Validation items={items} onSubmit={onSubmit} loading={loading} />
      </div>
    </>
  )
}

export default ForgotPassword
